import { WorkspaceInvitation } from '@/gen-api/models';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface InvitationsListProps {
  compact?: boolean;
  invitations: WorkspaceInvitation[] | undefined;
  isLoading: boolean;
  hasError: boolean;
  onAccept: (token: string) => void;
  onDecline: (token: string) => void;
  isAccepting: boolean;
  isDeclining: boolean;
}

export function InvitationsList({
  compact = false,
  invitations,
  isLoading,
  hasError,
  onAccept,
  onDecline,
  isAccepting,
  isDeclining,
}: InvitationsListProps) {
  return (
    <div className="space-y-4" data-testid="invitations-list">
      {compact ? (
        <span className="text-sm text-muted-foreground">Pending Invitations</span>
      ) : (
        <h3 className="text-lg font-semibold" data-testid="invitations-title">
          Pending Invitations
        </h3>
      )}
      {isLoading ? (
        <div className="flex justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      ) : hasError ? (
        <p className="text-destructive text-center">Could not load invitations.</p>
      ) : invitations && invitations.length > 0 ? (
        <ul className="space-y-3">
          {invitations.map((invite) => (
            <li key={invite.id} className="flex items-center justify-between p-3 border rounded-md bg-card">
              <div>
                {/* @ts-expect-error workspace is not in the model */}
                <h3 className="text-sm font-semibold truncate">{invite.workspace.name}</h3>
                {!compact && <p className="text-sm text-muted-foreground">Invited by: {invite.invited_by_email}</p>}
              </div>
              <div className="flex gap-2">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onDecline(invite.token)}
                  disabled={isAccepting || isDeclining}
                >
                  {isDeclining ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : null}
                  Decline
                </Button>
                <Button size="sm" onClick={() => onAccept(invite.token)} disabled={isAccepting || isDeclining}>
                  {isAccepting ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : null}
                  Accept
                </Button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-muted-foreground text-center">You have no pending invitations.</p>
      )}
    </div>
  );
}
